import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { Switch } from '@material-ui/core';

const typesStatusConnection = [
  { state: 'notConnected', color: '#DD4348', label: 'Sin conexión' },
  { state: 'failure', color: '#999999', label: 'Error' },
  { state: 'onLine', color: '#4BBC68', label: 'Conectado' }
];

const FormSatState = props => {
  const { enabled, integrationEnabled, disabledIntegration, display = true } = props;
  const [statusConnection, setStatusConnection] = useState({});

  useEffect(() => {
    stateConnection();
  }, [enabled, integrationEnabled]);

  const stateConnection = () => {
    const { connection } = props;
    setStatusConnection(typesStatusConnection.find(e => e.state === connection));
  };

  return (
    <React.Fragment>
      <div style={enabled && integrationEnabled ? { paddingRight: '0px' } : { paddingRight: '12px' }}>
        <Row>
          <Col xs={7}>
            <div className="status-point" style={{ backgroundColor: statusConnection.color }}></div>
            <p className="status-label" style={{ color: statusConnection.color }}>
              {statusConnection.label}
            </p>
            <p className="instructions-link" style={{ marginTop: '0px' }}>
              <a href="https://help.porcobrar.com/es/" target="_blank" rel="noreferrer">
                Consulta las instrucciones de integración
              </a>
            </p>
          </Col>
          <Col xs={{ size: 3, offset: 2 }}>
            {display && (
              <div className="state-switch">
                <p>{enabled && integrationEnabled ? 'Activada' : 'Desactivada'}</p>
                <Switch
                  checked={enabled === 1 && integrationEnabled === 1 ? true : false}
                  color="primary"
                  onClick={disabledIntegration}
                />
              </div>
            )}
          </Col>
        </Row>
      </div>
    </React.Fragment>
  ); // END return
}; // END FormOxxoInstructions

FormSatState.propTypes = {
  enabled: PropTypes.any,
  integrationEnabled: PropTypes.any,
  disabledIntegration: PropTypes.any,
  connection: PropTypes.any,
  display: PropTypes.bool
};

export default FormSatState;



// WEBPACK FOOTER //
// ./src/containers/account/components/satIntegration/FormSatState.js